export enum SubscriptionType {
    ENGAGEMENT = 'ENGAGEMENT',
    PROJECT = 'PROJECT',
    TENANT = 'TENANT',
}
